import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CheckCircle } from 'lucide-react';

/**
 * Vollflächige Erfolgs-Bestätigung nach Session-Beitritt (Code / QR-Scan).
 * Großer grüner Haken + hüpfender Otter 🦦, schließt sich automatisch.
 */
const SessionJoinSuccess = ({ title, message, onDone, duration = 1800 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (typeof onDone === 'function') onDone();
    }, duration);
    return () => clearTimeout(timer);
  }, [onDone, duration]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in px-6"
      role="status"
      aria-live="polite"
      onClick={onDone}
    >
      {/* Scoped Pop-Animation für den Haken */}
      <style>{`
        @keyframes joinPop {
          0% { transform: scale(0.3); opacity: 0; }
          60% { transform: scale(1.15); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>

            {/* Radius und Schatten wie ui/Modal: Das Overlay ist zwar kein Dialog (es hat
          keine Bedienelemente und schliesst sich selbst), soll aber nicht als
          Fremdkoerper danebenstehen. Vorher rounded-3xl + rohes shadow-token-xl. */}
      <div className="bg-surface rounded-3xl shadow-token-xl px-8 py-10 max-w-sm w-full flex flex-col items-center text-center">
        {/* Grüner Haken mit Pop-In */}
        <div
          className="relative mb-2"
          style={{ animation: 'joinPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both' }}
        >
          <div className="absolute inset-0 rounded-full bg-success-soft scale-150" />
          <CheckCircle className="relative h-20 w-20 text-success" strokeWidth={2.5} aria-hidden="true" />
        </div>

        {/* Hüpfender Otter */}
        <div className="text-5xl mt-2 animate-bounce" aria-hidden="true">🦦</div>

        <h2 className="text-2xl font-bold text-foreground mt-4">
          {title || 'Du bist dabei'}
        </h2>
        {message && (
          <p className="text-sm sm:text-base text-muted-foreground mt-2">{message}</p>
        )}
      </div>
    </div>
  );
};

SessionJoinSuccess.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onDone: PropTypes.func.isRequired,
  duration: PropTypes.number,
};

export default SessionJoinSuccess;
